import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import { updateaddmission, getaddmission, deleteaddmissions, } from '../../ReduxToolkit/Slice/Addmission/Addmission';
import 'react-loading-skeleton/dist/skeleton.css';
import Button from '../../components/Button/Button';
import PageTitle from '../../components/Title/PageTitle';
import { ToastContainer } from "react-toastify";
import Registration from './Registration';
import Input from '../../components/Input/Input';


function Addmission() {
  const dispatch = useDispatch();
  const closeButtonRef = useRef(null);
  const { status, addmissions } = useSelector((state) => state.addmission);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [dob, setDob] = useState('');
  const [stander, setStander] = useState('');
  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getaddmission());
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (addmissionid) => {
    const Isconfirmed = window.confirm("Are you sure! you want delete this Form ?")
    if (Isconfirmed) {
      dispatch(deleteaddmissions(addmissionid))
    };
  }
  // single data fetch
  const [selectedId, setSelectedId] = useState(null);
  const handlid = (id) => {
    const selectedaddmissions = addmissions.data.find(plan => plan._id === id);
    setName(selectedaddmissions.name);
    setEmail(selectedaddmissions.email);
    setPhone(selectedaddmissions.phone);
    setDob(selectedaddmissions.dob);
    setStander(selectedaddmissions.stander);
    setSelectedId(id);
  };
  // update
  const handleEdit = (e) => {
    e.preventDefault()
    const data = {
      name,
      email,
      phone,
      dob,
      stander
    };
    dispatch(updateaddmission({ selectedId, data }))
    setName('');
    setEmail('');
    setPhone('');
    setDob('');
    setStander('');
    closeButtonRef.current.click();
  }
  return (
    <>
      <div>
        <ToastContainer />
        <div className='d-flex justify-content-between my-3'>
          <PageTitle children={"Addmissions"} />
          <Registration />
        </div>
        <div className='table-responsive'>
          <table className="table table-hover">
            <thead className="table-primary">
              <tr>
                <th scope="col">S.no</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col">Dob</th>
                <th scope="col">standard</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {status === "loading" && (
                <tr className='my-2'>
                  <td colSpan={8}>
                    <Skeleton count={10} height={90} />
                  </td>
                </tr>
              )}
              {status === "failed" && (
                <tr>
                  <td colSpan={8}>
                    <p className='text-center fw-bold'>{"Data not found"}</p>
                  </td>
                </tr>
              )}
              {status === "succeeded" && addmissions.data && addmissions.data.map((addmission, index) => (
                <tr key={addmission._id}>
                  <th scope="row">{index + 1}</th>
                  <td>{addmission.name}</td>
                  <td>{addmission.email}</td>
                  <td>{addmission.phone}</td>
                  <td>{addmission.dob}</td>
                  <td>{addmission.stander}</td>
                  <td className='cursor'>
                    <div onClick={() => handlid(addmission._id)}><i className='bi bi-pencil-square text-primary fs-5' data-bs-toggle="modal" data-bs-target="#exampleModal"></i></div>
                    <div onClick={() => handleDelete(addmission._id)}><i className='bi bi-trash text-danger fs-5'></i></div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal  */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Addmission Form
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form action=""
                onSubmit={handleEdit}
              >
                <Input
                  label="Name"
                  type="text"
                  placeholder="Name"
                  value={name}
                  required
                  onChange={(e) => setName(e.target.value)}
                />
                <Input
                  label="Email"
                  type="email"
                  placeholder="Email"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Input
                  label="Phone"
                  type="phone"
                  placeholder="Enter Your Number"
                  value={phone}
                  required
                  onChange={(e) => setPhone(e.target.value)}
                />
                <Input
                  label="Date of Birth"
                  type="date"
                  value={dob}
                  required
                  onChange={(e) => setDob(e.target.value)}
                />
                <Input
                  label="Course"
                  type="text"
                  value={stander}
                  required
                  placeholder="Standard"
                  onChange={(e) => setStander(e.target.value)}
                />

                <div className={`modal-footer`}>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={closeButtonRef}
                  >
                    Close
                  </button>
                  <Button type="submit" children={"Update"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Addmission;
